import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const coreLinks = categories.slice(0, 7);
  const moreLinks = categories.slice(7);

  const articleLinks = [
    { to: "/pandabuy-sheet-ultimate-guide", label: "Ultimate Spreadsheet Guide" },
    { to: "/article/pandabuy-sheet-shoes-guide", label: "Shoes Guide" },
    { to: "/article/pandabuy-sheet-hoodies-guide", label: "Hoodies Guide" },
    { to: "/article/pandabuy-sheet-jackets-guide", label: "Jackets Guide" },
    { to: "/article/pandabuy-sheet-accessories-guide", label: "Accessories Guide" },
    { to: "/article/pandabuy-sheet-budget-finds", label: "Budget Finds" },
    { to: "/article/pandabuy-sheet-viral-tiktok", label: "Viral TikTok Finds" },
    { to: "/article/pandabuy-sheet-quality-tips", label: "Quality Tips" },
    { to: "/article/pandabuy-sheet-beginner-guide", label: "Beginner Guide" },
    { to: "/article/pandabuy-sheet-trending-2026", label: "Trending 2026" },
  ];

  return (
    <footer className="bg-background-200 pt-16 md:pt-20 pb-8 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          <div>
            <span className="text-lg font-heading font-bold text-foreground-950">
              PandaBuy<span className="font-normal italic">.Courses</span>
            </span>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed max-w-xs">
              The ultimate pandabuyspreadsheet hub — curated, updated, and organized for
              shoppers who value their time.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-500 mb-4">Categories</h4>
            <ul className="space-y-2.5">
              {coreLinks.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.link}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-500 mb-4">More Categories</h4>
            <ul className="space-y-2.5">
              {moreLinks.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.link}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-500 mb-4">SEO Guides</h4>
            <ul className="space-y-2">
              {articleLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors leading-snug"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-300 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 PandaBuy.Courses &mdash; All external links open on kaspreadsheet.com
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-8 h-8 rounded-lg bg-background-300 flex items-center justify-center hover:bg-background-400 transition-colors"
              aria-label="External link"
            >
              <i className="ri-external-link-line text-foreground-500 text-sm"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-8 h-8 rounded-lg bg-background-300 flex items-center justify-center hover:bg-background-400 transition-colors"
              aria-label="Shopping link"
            >
              <i className="ri-shopping-bag-line text-foreground-500 text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}